import { DocumentDuplicateIcon } from '@heroicons/react/outline';
import React from 'react'
import { useRecoilValue } from 'recoil';
import { contentDetail } from '../../recoil/content';

const DocsList = () => {
  const content = useRecoilValue(contentDetail);

  const loadDocs = () => {
    return (
      <div className="flex flex-col gap-3">
          {
              content.documents.map((item, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 px-3 py-2 rounded-lg hover:bg-slate-100">
                      <a href={item} target="_blank" rel="noreferrer" title="Lihat Dokumen" className="flex-1 cursor-pointer overflow-clip hover:text-blue-600">{"Dokumen "+(i+1)}</a>
                  </div>
              ))
          }
      </div>
    );
  };

  return (
    <div className="flex flex-col items-start">
        <label htmlFor="document" className="text-sm">Dokumen</label>
        <div className="flex items-start w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
            <DocumentDuplicateIcon className="w-6 h-6" />
            <div className="flex flex-col flex-1 gap-3">
                {loadDocs()}
            </div>
        </div>
    </div>
  )
}

export default DocsList